import {
  useConfigToken,
  useInitializeServiceToken,
  useNavigationService,
  useTrackingServiceToken,
} from '../src/di/di.root-container.hooks';

import {useEffect, useMemo} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {BrowserRouter as Router, Routes} from 'react-router-dom';

import {routes} from '@/routes';
import {ScrollToTop} from '@/ui/common/ScrollToTop/ScrollToTop';
import {SvgFilters} from '@/ui/kit/icons/filters/SvgFilters';

export default function App(): JSX.Element {
  const initializeService = useInitializeServiceToken();

  // сервисы должны начать инициализироваться до рендера AppRoutes, в противном случае AppRoutes отрендерятся с isMb === false,
  // а затем isMb === true внутри мобильного экрана, т.к. useEffect вызывается уже после рендера
  // @see: https://jira.tcsbank.ru/browse/SP-18178
  useMemo(() => {
    void initializeService.init();
  }, [initializeService]);

  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
      <SvgFilters />
    </Router>
  );
}

function AppRoutes(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const trackingService = useTrackingServiceToken();
  const navigationService = useNavigationService();
  const config = useConfigToken();

  // добавляем tracking.updateLocation, потому что при переходе между страницами нужно обновлять
  // адрес текущей страницы в объект window.tracking.state.url, автоматически этого не происходит,
  // поэтому требуется явно указывать, что location изменился
  useEffect(() => {
    trackingService.updateLocation();
  }, [location]);

  // вся навигация в приложении будет происходить через manager, для этого необходимо передать navigationService
  // имплементацию функции navigate из пакета react-router-dom
  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  if (config.isProd) {
    return <Routes>{routes.prod}</Routes>;
  }

  return <Routes>{routes.stage}</Routes>;
}
